import selectDefaultListId from "../fetch-default-list/select";
import getFetchDefaultListOptions from "../fetch-default-list/get-options";
var getDefaultListId = function getDefaultListId(_ref) {
  var queryClient = _ref.queryClient;
  return selectDefaultListId(queryClient.getQueryData(getFetchDefaultListOptions().queryKey));
};
export default getDefaultListId;